const API_BASE = process.env.VUE_APP_API_BASE || 'https://tyng-ca.com.my'

export async function apiFetch (url, options = {}) {
  const fullUrl = url.startsWith('http')
    ? url
    : `${API_BASE}${url}`

  return fetch(fullUrl, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    },
    ...options
  }).then(r => r.json())
}
